import { Typography } from "@mui/material";
import { createButton } from "../../../../helpers/html/createButton";
import { participanteAccountsInfo, patrocinadorAccountsInfo } from "./bankAccounts";
import moment from "moment";


const styles = {
    divMain:{ width:'96%', padding:'10px', marginRight: '4%', backgroundColor:'white' },
    divLogo:{ textAlign:'center', width:'100%' },
    divWhite:{ textAlign:'center', width:'100%', padding:'4px 0' },
    divFramed:{ border:'1px solid gray', width:'100%', padding:'4px', marginBottom: '4px' },
    divButton: { background:'#87CEEB', padding:'4px 9px', cursor:'pointer', textUnderline: 'none' },
}

export const setCommonInfo = (datosParticipante, datosRegistro) => {

    const { tipoRegistro } = datosParticipante;

    return (
        <>
            <p>
                Nombre completo / Full name:<br /> 
                <strong>{ datosParticipante.partNombres } { datosParticipante.partApellidoPaterno } { datosParticipante.partApellidoMaterno }</strong> <br />
                {/* Correo: <br /> */}
                <strong>{ datosParticipante.partCorreo }</strong> <br />
            </p>
            <p>
                Numero de referencia / Reference id:<br />
                <strong>{ datosParticipante.registroReferencia }</strong>
            </p>
            <p>
                Registrado como / Registered as:<br /> 
                <strong>{ tipoRegistro }</strong>
            </p>
            {
                tipoRegistro !== 'Patrocinador'
                ? <p>Modalidad / Modality:<br />
                    <strong>{ datosRegistro.modalidad }</strong>
                </p>
                : <></>
            }
        </>
    )
}

export const setFooterInfo = () => {
    return (
        <>
            <p>
                <br />
                Atentamente / Sincerely:<br /> 
                <strong>Comité Organizador / Organizing Committee</strong>
            </p>
        </>
    )
}

export const setBodyFirstMail = ({ datosParticipante, datosRegistro, contenidoExtra = '' }) => {

    console.log({ datosParticipante, datosRegistro });
    const { registroReferencia, tipoRegistro } = datosParticipante;
    const { modalidad } = datosRegistro;


    return (
        <div style={styles.divMain}>
            <div style={styles.divLogo}>
                <img src={ datosRegistro.urlLogo } alt="logo" width={ 100 } />
            </div>
            <div style={styles.divWhite}>
                <h2><i>{ datosRegistro.tituloEvento }</i></h2>
            </div>
            <div>
                { setCommonInfo(datosParticipante, datosRegistro) }
                {
                    tipoRegistro === 'Patrocinador'
                    ? <>
                        { patrocinadorAccountsInfo(registroReferencia) }
                    </>
                    : <></>
                }
                <div dangerouslySetInnerHTML={{ __html: contenidoExtra }} />
                {
                    (modalidad === 'Asistente' || modalidad === 'Participante')
                    ? <>
                        { participanteAccountsInfo(registroReferencia) }
                    </>
                    : <></>
                }

            </div>
            { setFooterInfo() }
        </div>
    );
};


export const setWorksInfo = (trabajos, registroReferencia) => {
    return (
        <>
            <div style={styles.divWhite}>
                <h4><i>Trabajos / Works</i></h4>
            </div>
            {
                trabajos.map((t, i) => <div key={ i } style={ styles.divFramed }>
                    <p>
                        Título del trabajo / Work title:<br /> 
                        <strong>{ t.title }</strong>
                    </p>
                    <p>
                        Estatus / Status:<br /> 
                        <strong>{ t.status }</strong>
                    </p>
                    <p>
                        Comentarios / Comments:<br /> 
                        <strong>{ t.statusComments }</strong>
                    </p>
                </div>
                )
            }
            <p>
                <a href={ `${ process.env.REACT_APP_HOMEPAGE }/sina2025/trabajos/edicion?id=${ registroReferencia }` } target='_blank'>
                    <button style={ styles.divButton }>
                        Gestionar trabajos / Works management
                    </button>
                </a>
            </p> 
        </>
    );
}


export const setBodyPersonalEmailLink = ({ datosParticipante, datosRegistro }) => {
    const { registroReferencia, tipoRegistro, infoAdicional } = datosParticipante;
    console.log({ datosRegistro });

    return (
        <div style={styles.divMain}>
            <div style={styles.divLogo}>
                <img src={ datosRegistro.urlLogo } alt="logo" width={ 100 } />
            </div>
            <div style={styles.divWhite}>
                <h2><i>{ datosRegistro.tituloEvento }</i></h2>
            </div>

            <p>
                <strong>¡Hola, le damos la bienvenida a nuestro evento!<br />
                Hi, wellcome to our event!<br /></strong>
                <br /> 
                Si es la primera vez que ingresa, utilice el siguiente enlace para establecer una contraseña:<br /> 
                Plese, use this link to set a password:<br /> 
                <button style={ styles.divButton }>
                    Establece una contraseña / Set a password
                </button>
            </p>
            <p>
                Si ya cuenta con ella, puedes ingresar directamente aqui:<br /> 
                If you already have it, you can access here:<br /> 
                <a href={ 'https://cib-eventos.vercel.app/auth/login' } target='_blank'>
                    <button style={ styles.divButton }>
                        Ingresar / Login
                    </button>
                </a>
            </p>

            { setFooterInfo() }

        </div>
    )
}


export const setBodyNotification = ({ datosParticipante, datosRegistro }) => {
    const { registroReferencia, tipoRegistro, infoAdicional } = datosParticipante;
    const { modalidad, trabajos } = infoAdicional;
    console.log({ modalidad, tipoRegistro });

    return (
        <div style={styles.divMain}>
            <div style={styles.divLogo}>
                <img src={ datosRegistro.urlLogo } alt="logo" width={ 100 } />
            </div>
            <div style={styles.divWhite}>
                <h2><i>{ datosRegistro.tituloEvento }</i></h2>
            </div>
            <div>
                { setCommonInfo(datosParticipante, datosRegistro) }
            </div>
            {
                setWorksInfo(trabajos, registroReferencia)
            }

            {/* <div style={styles.divWhite}>
                <h4><i>Trabajos / Works</i></h4>
            </div>
            {
                trabajos.map((t, i) => <div key={ i } style={ styles.divFramed }>
                    <p>
                        Título del trabajo / Work title:<br /> 
                        <strong>{ t.title }</strong>
                    </p>
                    <p>
                        Estatus / Status:<br /> 
                        <strong>{ t.status }</strong>
                    </p>
                    <p>
                        Comentarios / Comments:<br /> 
                        <strong>{ t.statusComments }</strong>
                    </p>
                </div>
                )
            }
            <p>
                <a href={ `${ process.env.REACT_APP_HOMEPAGE }/sina2025/trabajos/edicion?id=${ registroReferencia }` } target='_blank'>
                    <button style={ styles.divButton }>
                        Gestionar trabajos / Works management
                    </button>
                </a>
            </p>  */}


            <div style={styles.divWhite}>
                <h4><i>Información para pago / Payment info</i></h4>
            </div>
            {
                participanteAccountsInfo(registroReferencia)
            }
            <p>
                <a href={ `${ process.env.REACT_APP_HOMEPAGE }/sina2025/comprobar-pago/${ registroReferencia }` } target='_blank'>
                    <button style={ styles.divButton }>
                    Subir comprobante de pago / Upload proof of payment
                    </button>
                </a>
            </p> 
            { setFooterInfo() }
        </div>
    );
}



export const setBodyPaymentReceived = ({ datosParticipante, datosRegistro }) => {
    const { registroReferencia, tipoRegistro, infoAdicional } = datosParticipante;
    const { datosFactura } = infoAdicional;
    console.log({ datosFactura });

    return (
        <div style={styles.divMain}>
            <div style={styles.divLogo}>
                <img src={ datosRegistro.urlLogo } alt="logo" width={ 100 } />
            </div>
            <div style={styles.divWhite}>
                <h2><i>{ datosRegistro.tituloEvento }</i></h2>
            </div>
            <div>
                { setCommonInfo(datosParticipante, datosRegistro) }
            </div>
            <p>
                Comprobante de pago entregado el / Proof of payment delivered at:<br />
                <strong>{ moment(datosFactura.updatedAt).format('DD/MM/YYYY') }</strong>
            </p>
        </div>
    );
}